import React from 'react';
import axios from 'axios';
import { ButtonGroup, Button, Modal, Glyphicon, FormGroup, ControlLabel, FormControl } from 'react-bootstrap';
import { BootstrapTable, TableHeaderColumn } from 'react-bootstrap-table';
import AddPassModal from './AddPass';
import UpdatePassModal from './UpdatePass';
import {isLoggedIn } from '../../utils/AuthService';

var StanPass = React.createClass({

	getInitialState: function() {
		return {
			data: null,
			selectedPassId: null,
			showAddModal: false,
			showUpdateModal: false
		}
    },

	componentDidMount: function() {
		this.refreshTable();
	},

	render: function() {

		var selectRowProp = {
			mode: "radio",
			clickToSelect: true,
			className: "selected-row",
			bgColor: 'rgb(101, 148, 255)',
			onSelect: this.onRowSelect
		};

		if(!isLoggedIn()){
			return (<div></div>);
		};

		return (
			<div>
				<ButtonGroup className="m-10">
					<Button bsStyle="primary" onClick={this.openAddModal}><Glyphicon glyph="plus" />Dodaj Listwę passepartout</Button>
					<Button bsStyle="warning" disabled={this.state.selectedPassId === null} onClick={this.openUpdateModal}><Glyphicon glyph="refresh" />Aktualizuj</Button>
					<Button bsStyle="danger" disabled={this.state.selectedPassId === null} onClick={this.onDeleteBtnClicked}><Glyphicon glyph="trash" />Usuń</Button>
				</ButtonGroup>

				<BootstrapTable data={this.state.data}
					striped={true}
					hover={true}
					pagination={true}
					search={true}
					selectRow={selectRowProp}>
						<TableHeaderColumn dataField="id" isKey={true} dataSort={true}>ID</TableHeaderColumn>
						<TableHeaderColumn dataField="numerPass" dataSort={true}>Numer listwy passepartout</TableHeaderColumn>
						<TableHeaderColumn dataField="iloscCm" dataSort={true}>Ilość cm</TableHeaderColumn>
						<TableHeaderColumn dataField="ilot" dataSort={true}>Ilot</TableHeaderColumn>
				</BootstrapTable>

				<AddPassModal parent={this} ref="addPass" />
				<UpdatePassModal parent={this} ref="updatePass"/>

			</div>
		);
	},

	onRowSelect: function(row, isSelected) {
		if(isSelected) {
			this.setState({ selectedPassId: row.id });
		}else {
			this.setState({ selectedPassId: null });
		}
	},

	closeAddModal: function() {
		this.setState({ showAddModal: false });
		this.refs.addPass.clearAddObject();
	},

	openAddModal: function() {
		this.refs.addPass.clearAddObject();
		this.setState({ showAddModal: true });
	},

	closeUpdateModal: function() {
		this.setState({showUpdateModal: false});
		this.refs.updatePass.clearUpdateObject();
	},

	openUpdateModal: function() {
		this.refs.updatePass.fillUpdateObject();
		this.setState({showUpdateModal: true});
	},

	onDeleteBtnClicked: function() {
		axios.delete('http://217.182.200.222:8080/stanPass/' + this.state.selectedPassId)
			.then(function (response) {
				this.refreshTable();
			}.bind(this))
			.catch(function (error) {
				console.log(error);
			});
	},

	getPassById: function(id) {
		for(var i in this.state.data) {
			if(this.state.data[i].id === id) {
				return this.state.data[i];
			}
		}
		return '';
	},

	refreshTable: function() {
		axios.get('http://217.182.200.222:8080/stanPass')
		.then(function (stanPass) {
			this.setState({data: stanPass.data});
		}.bind(this));
	}
});

export default StanPass;



// WEBPACK FOOTER //
// ./src/components/StanPass/StanPass.js